import React from "react";
import { Row, Spinner } from "react-bootstrap";
import UserGetOrdersHook from "../../hook/user/UserGetOrdersHook";
import UserAllOrderItem from "./UserAllOrderItem";
import Pagination from "../../Components/Utilities/Pagination";
import Cookies from "js-cookie";

import { useTranslation } from "react-i18next";

const UserAllOrder = () => {
  const { t } = useTranslation()
  const [ username,
    result,
    orderData,
    noPages,
    onPress,
    clickHandler,
    handlePrintShipments,
    user,
    showModalReturnProduct,
    description,
    show,
    onChangeDescription,
    handleCloseModel,
    saveReturnProduct,
    loading,
    setLoading
   ] = UserGetOrdersHook();

 // if(!loading) return <Spinner />;

 console.log('orderData',orderData);
// let filteredOrderData=orderData.filter(el=>el.refund!='pending');

  return (
    <div className="orders-page-container">
      <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-3">
        <div>
          <h4 style={{ fontWeight: 800, color: 'var(--primary-color)' }}>{Cookies.get("i18next") === 'ar' ? "طلباتي" : "My Orders"}</h4>
          <p className="text-muted mb-0" style={{ fontSize: '14px' }}>{Cookies.get("i18next") === 'ar' ? "تتبع وإدارة طلباتك السابقة" : "Track and manage your recent orders"}</p>
        </div>
        <div className="bg-light px-3 py-2 rounded" style={{ fontSize: '13px', fontWeight: 600 }}>
          {t("Total Orders")}: <span className="text-primary">{result}</span>
        </div>
      </div>
      <Row className="g-4">
        {orderData.length >= 1 ? (
          orderData.map((el) =><UserAllOrderItem key={el._id} orderItem={el} setLoading={setLoading} loading={loading}   /> )
        ) : (
          <h6>{t("no orders yet")}</h6>
        )}
        <Pagination pageCount={noPages || 0} onPress={onPress} />
      </Row>
    </div>
  );
};

export default UserAllOrder;
